/* eslint-disable react/no-unknown-property */
import React, { Component } from "react";
import {
  Phone,
  Shield,
  CheckCircle,
  AlertCircle,
  QrCode,
  ArrowLeft,
  Send,
  Hash,
} from "lucide-react";
import { Navigate } from "react-router-dom";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

export default class Forgot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      step: 1,
      phone: "",
      otp: ["", "", "", "", ""],
      message: { type: "", text: "" },
      shouldRedirect: null,
      countdown: 0,
    };
  }

  handleRegisterNavigation = () => {
    this.setState({ shouldRedirect: "/register" });
  };

  handleLoginNavigation = () => {
    this.setState({ shouldRedirect: "/login" });
  };

  handleOtpChange = (index, value) => {
    if (value.length > 1) return;

    const newOtp = [...this.state.otp];
    newOtp[index] = value;
    this.setState({ otp: newOtp });

    if (value && index < 4) {
      document.getElementById(`otp-${index + 1}`)?.focus();
    }
  };

  handleOtpKeyDown = (index, e) => {
    if (e.key === "Backspace" && !this.state.otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`)?.focus();
    }
  };

  handleSendOtp = (e) => {
    e.preventDefault();
    if (!this.state.phone) {
      this.setState({
        message: {
          type: "error",
          text: "Lütfen geçerli bir telefon numarası girin.",
        },
      });
      return;
    }

    this.setState({ isLoading: true });

    setTimeout(() => {
      this.setState({
        isLoading: false,
        step: 2,
        countdown: 120,
        message: {
          type: "success",
          text: "Telefon numaranıza 5 haneli doğrulama kodu gönderildi.",
        },
      });
      this.startCountdown();
    }, 1500);
  };

  handleVerifyOtp = (e) => {
    e.preventDefault();
    const otpCode = this.state.otp.join("");
    if (otpCode.length !== 5) {
      this.setState({
        message: {
          type: "error",
          text: "Lütfen 5 haneli doğrulama kodunu tam olarak girin.",
        },
      });
      return;
    }

    this.setState({ isLoading: true });

    setTimeout(() => {
      if (otpCode === "12345") {
        this.setState({
          isLoading: false,
          message: {
            type: "success",
            text: "Doğrulama başarılı! Yeni şifre oluşturma sayfasına yönlendiriliyorsunuz...",
          },
        });
        setTimeout(
          () => this.setState({ shouldRedirect: "/reset-password" }),
          2000
        );
      } else {
        this.setState({
          isLoading: false,
          message: {
            type: "error",
            text: "Girdiğiniz doğrulama kodu hatalı. Lütfen tekrar deneyin.",
          },
        });
      }
    }, 1500);
  };

  startCountdown = () => {
    const timer = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.countdown <= 1) {
          clearInterval(timer);
          return { countdown: 0 };
        }
        return { countdown: prevState.countdown - 1 };
      });
    }, 1000);
  };

  handleResendOtp = () => {
    this.setState({ isLoading: true, otp: ["", "", "", "", ""] });
    setTimeout(() => {
      this.setState({
        isLoading: false,
        countdown: 120,
        message: { type: "success", text: "Yeni doğrulama kodu gönderildi." },
      });
      this.startCountdown();
      document.getElementById("otp-0")?.focus();
    }, 1000);
  };

  handleBackToPhone = () => {
    this.setState({
      step: 1,
      countdown: 0,
      otp: ["", "", "", "", ""],
      message: { type: "", text: "" },
    });
  };

  formatCountdown = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.message.text !== this.state.message.text &&
      this.state.message.text
    ) {
      setTimeout(
        () => this.setState({ message: { type: "", text: "" } }),
        7000
      );
    }
  }

  renderMessage = () => {
    const { message } = this.state;
    if (!message.text) return null;

    return (
      <div
        style={{
          background:
            message.type === "success"
              ? "linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)"
              : "linear-gradient(135deg, #fef2f2 0%, #fecaca 100%)",
          border: `1px solid ${
            message.type === "success" ? "#10b981" : "#ef4444"
          }`,
          borderRadius: "12px",
          padding: "15px 20px",
          marginBottom: "25px",
          color: message.type === "success" ? "#065f46" : "#991b1b",
          fontSize: "14px",
          fontWeight: "600",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        {message.type === "success" ? (
          <CheckCircle size={16} />
        ) : (
          <AlertCircle size={16} />
        )}
        {message.text}
      </div>
    );
  };

  render() {
    const { step, phone, otp, isLoading, countdown, shouldRedirect } =
      this.state;

    if (shouldRedirect) {
      return <Navigate to={shouldRedirect} replace />;
    }

    return (
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
        }}
      >
        <div
          style={{
            background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
            borderRadius: "24px",
            padding: "50px",
            boxShadow: "0 25px 80px rgba(0,0,0,0.15)",
            width: "100%",
            maxWidth: "500px",
            position: "relative",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "-15px",
              left: "50%",
              transform: "translateX(-50%)",
              background: "#ffffff",
              padding: "8px 20px",
              borderRadius: "20px",
              border: "1px solid #e2e8f0",
              boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontSize: "12px",
              fontWeight: "600",
              color: "#64748b",
            }}
          >
            <Shield
              size={14}
              style={{ color: step === 1 ? "#f59e0b" : "#3b82f6" }}
            />
            {step === 1 ? "Güvenli SMS" : "Kod Doğrulama"}
          </div>

          {this.renderMessage()}

          {step === 1 ? (
            <>
              <div style={{ textAlign: "center", marginBottom: "40px" }}>
                <div
                  style={{
                    background:
                      "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 25px",
                    color: "white",
                    boxShadow: "0 8px 25px rgba(245, 158, 11, 0.25)",
                  }}
                >
                  <Phone size={35} />
                </div>

                <h2
                  style={{
                    fontSize: "28px",
                    fontWeight: "700",
                    marginBottom: "10px",
                    color: "#1e293b",
                  }}
                >
                  Şifrenizi mi Unuttunuz?
                </h2>
                <p
                  style={{
                    color: "#64748b",
                    fontSize: "16px",
                    lineHeight: "1.6",
                    margin: "0",
                  }}
                >
                  Telefon numaranızı girin, size 5 haneli bir kod gönderelim.
                </p>
              </div>

              <form onSubmit={this.handleSendOtp}>
                <div style={{ marginBottom: "30px" }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontSize: "15px",
                      fontWeight: "600",
                      color: "#374151",
                    }}
                  >
                    Telefon Numarası
                  </label>
                  <PhoneInput
                    placeholder="Telefon numaranızı girin"
                    value={phone}
                    onChange={(setPhone) => this.setState({ phone: setPhone })}
                    defaultCountry="TR"
                    international
                    countryCallingCodeEditable={false}
                    style={{
                      "--PhoneInput-color--focus": "#f59e0b",
                      "--PhoneInputCountryFlag-borderColor": "#e2e8f0",
                      "--PhoneInputCountrySelectArrow-color": "#64748b",
                    }}
                  />
                  <p
                    style={{
                      color: "#64748b",
                      fontSize: "12px",
                      margin: "8px 0 0 0",
                    }}
                  >
                    Hesabınızda kayıtlı telefon numarasını girin
                  </p>
                </div>

                <button
                  type="submit"
                  disabled={isLoading}
                  style={{
                    background: isLoading
                      ? "#94a3b8"
                      : "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                    color: "white",
                    padding: "18px 40px",
                    border: "none",
                    borderRadius: "12px",
                    fontSize: "16px",
                    fontWeight: "600",
                    cursor: isLoading ? "not-allowed" : "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    justifyContent: "center",
                    width: "100%",
                    boxShadow: isLoading
                      ? "none"
                      : "0 8px 25px rgba(245, 158, 11, 0.3)",
                    marginBottom: "25px",
                    transition: "all 0.2s ease",
                  }}
                >
                  {isLoading ? (
                    <>
                      <div
                        style={{
                          width: "20px",
                          height: "20px",
                          border: "2px solid #ffffff",
                          borderTop: "2px solid transparent",
                          borderRadius: "50%",
                          animation: "spin 1s linear infinite",
                        }}
                      />
                      Gönderiliyor...
                    </>
                  ) : (
                    <>
                      <Send size={18} />
                      Doğrulama Kodu Gönder
                    </>
                  )}
                </button>
              </form>
            </>
          ) : (
            <>
              <div style={{ textAlign: "center", marginBottom: "40px" }}>
                <div
                  style={{
                    background:
                      "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 25px",
                    color: "white",
                    boxShadow: "0 8px 25px rgba(59, 130, 246, 0.25)",
                  }}
                >
                  <Hash size={35} />
                </div>

                <h2
                  style={{
                    fontSize: "28px",
                    fontWeight: "700",
                    marginBottom: "10px",
                    color: "#1e293b",
                  }}
                >
                  Doğrulama Kodu
                </h2>
                <p
                  style={{
                    color: "#64748b",
                    fontSize: "16px",
                    lineHeight: "1.6",
                    margin: "0",
                  }}
                >
                  Telefon numaranıza gönderilen 5 haneli kodu girin.
                </p>
              </div>

              <form onSubmit={this.handleVerifyOtp}>
                <div style={{ marginBottom: "30px", textAlign: "center" }}>
                  <div
                    style={{
                      display: "flex",
                      gap: "12px",
                      justifyContent: "center",
                      marginBottom: "15px",
                    }}
                  >
                    {otp.map((digit, index) => (
                      <input
                        key={index}
                        id={`otp-${index}`}
                        type="text"
                        inputMode="numeric"
                        maxLength="1"
                        value={digit}
                        onChange={(e) =>
                          this.handleOtpChange(index, e.target.value)
                        }
                        onKeyDown={(e) => this.handleOtpKeyDown(index, e)}
                        style={{
                          width: "50px",
                          height: "50px",
                          border: "2px solid #e2e8f0",
                          borderRadius: "8px",
                          fontSize: "24px",
                          fontWeight: "600",
                          textAlign: "center",
                          transition: "border-color 0.2s ease",
                        }}
                        onFocus={(e) =>
                          (e.target.style.borderColor = "#3b82f6")
                        }
                        onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
                      />
                    ))}
                  </div>

                  {countdown > 0 && (
                    <p
                      style={{
                        color: "#3b82f6",
                        fontSize: "14px",
                        fontWeight: "600",
                      }}
                    >
                      Kod geçerlilik süresi: {this.formatCountdown(countdown)}
                    </p>
                  )}
                </div>

                <button
                  type="submit"
                  disabled={isLoading}
                  style={{
                    background: isLoading
                      ? "#94a3b8"
                      : "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                    color: "white",
                    padding: "18px 40px",
                    border: "none",
                    borderRadius: "12px",
                    fontSize: "16px",
                    fontWeight: "600",
                    cursor: isLoading ? "not-allowed" : "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    justifyContent: "center",
                    width: "100%",
                    marginBottom: "15px",
                    transition: "all 0.2s ease",
                  }}
                >
                  {isLoading ? (
                    <>
                      <div
                        style={{
                          width: "20px",
                          height: "20px",
                          border: "2px solid #ffffff",
                          borderTop: "2px solid transparent",
                          borderRadius: "50%",
                          animation: "spin 1s linear infinite",
                        }}
                      />
                      Doğrulanıyor...
                    </>
                  ) : (
                    <>
                      <CheckCircle size={18} />
                      Kodu Doğrula
                    </>
                  )}
                </button>

                <div
                  style={{ display: "flex", gap: "10px", marginBottom: "25px" }}
                >
                  {countdown === 0 ? (
                    <button
                      type="button"
                      onClick={this.handleResendOtp}
                      disabled={isLoading}
                      style={{
                        background:
                          "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                        color: "white",
                        padding: "12px 20px",
                        border: "none",
                        borderRadius: "8px",
                        fontSize: "14px",
                        fontWeight: "600",
                        cursor: isLoading ? "not-allowed" : "pointer",
                        flex: 1,
                        transition: "all 0.2s ease",
                      }}
                    >
                      <Send size={16} style={{ marginRight: "6px" }} />
                      Yeni Kod Gönder
                    </button>
                  ) : (
                    <div
                      style={{
                        flex: 1,
                        padding: "12px 20px",
                        background: "#f3f4f6",
                        color: "#6b7280",
                        borderRadius: "8px",
                        fontSize: "14px",
                        fontWeight: "600",
                        textAlign: "center",
                      }}
                    >
                      Yeni kod: {this.formatCountdown(countdown)}
                    </div>
                  )}

                  <button
                    type="button"
                    onClick={this.handleBackToPhone}
                    style={{
                      background: "none",
                      border: "1px solid #e2e8f0",
                      color: "#64748b",
                      padding: "12px 20px",
                      borderRadius: "8px",
                      fontSize: "14px",
                      fontWeight: "600",
                      cursor: "pointer",
                      flex: 1,
                      transition: "all 0.2s ease",
                    }}
                  >
                    <ArrowLeft size={16} style={{ marginRight: "6px" }} />
                    Telefonu Değiştir
                  </button>
                </div>
              </form>
            </>
          )}

          <div
            style={{
              paddingTop: "20px",
              borderTop: "1px solid #e2e8f0",
              textAlign: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <button
                onClick={this.handleLoginNavigation}
                style={{
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  color: "white",
                  padding: "12px 25px",
                  border: "none",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  transition: "all 0.2s ease",
                }}
              >
                <QrCode size={16} />
                Giriş Sayfasına Dön
              </button>

              <button
                onClick={this.handleRegisterNavigation}
                style={{
                  background: "none",
                  border: "1px solid #e2e8f0",
                  color: "#64748b",
                  padding: "12px 25px",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  transition: "all 0.2s ease",
                }}
              >
                <ArrowLeft size={16} />
                Hesap Oluştur
              </button>
            </div>
          </div>
        </div>

        <style jsx>{`
          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }

          .PhoneInput {
            border: 2px solid #e2e8f0;
            border-radius: 12px;
            padding: 8px 15px;
            background: #ffffff;
            transition: border-color 0.2s ease;
          }

          .PhoneInput:focus-within {
            border-color: #f59e0b;
            box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.1);
          }

          .PhoneInputInput {
            border: none !important;
            outline: none !important;
            font-size: 16px;
            padding: 10px 0;
          }

          .PhoneInputCountrySelect {
            border: none;
            background: none;
            padding: 8px;
          }

          @media (max-width: 480px) {
            .main-container {
              padding: 25px 20px !important;
            }
          }

          button:hover:not(:disabled) {
            transform: translateY(-1px);
          }
        `}</style>
      </div>
    );
  }
}
